<div class="container-cuentas-obligatorias">
  <div class="wrapper">   
    <div class="grid-container">
      <ion-text class="title ion-text-start">Cuentas Obligatorias</ion-text>
      <ion-grid class="grid">
        <ion-row class="grid-header">
          <ion-col class="left-header-col" size="2"> 
              <ion-text class="grid-header-text">Elige</ion-text></ion-col>
          <ion-col class="mid-header-col" size="5">
              <ion-text class="grid-header-text">Cuenta</ion-text></ion-col>
          <ion-col class="right-header-col">
              <ion-text class="grid-header-text">Saldo a congelar</ion-text></ion-col>
        </ion-row>
        <ion-row class="grid-content-cco" id="row-cco" *ngIf="ccoAmount > 0">
          <ion-col class="left-col" size="2">
              <ion-checkbox (ionChange)="ccoCheckboxClick($event)"></ion-checkbox></ion-col>
          <ion-col class="mid-col" size="5">
              <ion-text class="account-type-text">Ahorro Obligatorio <br></ion-text>
              <ion-text class="account-amount-text">
                  Saldo: {{ numberToChileanCurrency(ccoAmount) }}</ion-text>
          </ion-col>
          <ion-col class="right-col">
            <ion-text class="selected-amount-text">{{getSelectedCCOAmmount()}}</ion-text>
          </ion-col>
        </ion-row>
        <ion-row class="grid-content-cdc" id="row-cdc" *ngIf="cdcAmount > 0">
          <ion-col class="left-col" size="2">
              <ion-checkbox (ionChange)="cdcCheckboxClick($event)"></ion-checkbox></ion-col>
          <ion-col class="mid-col" size="5">
              <ion-text class="account-type-text">
                  Depósito Convenido<br></ion-text>
              <ion-text class="account-amount-text">
                  Saldo: {{ numberToChileanCurrency(cdcAmount) }}</ion-text>
          </ion-col>
          <ion-col class="right-col">
            <ion-text class="selected-amount-text">{{getSelectedCDCAmmount()}}</ion-text>
          </ion-col>
        </ion-row>
        <ion-row class="grid-content-total">
          <ion-col  class="left-col" size="7">
              <ion-text class="selected-amount-text">Total a congelar</ion-text></ion-col>
          <ion-col class="right-col">
              <ion-text class="selected-amount-text">{{ numberToChileanCurrency(selectedAmount) }}</ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
</div>